// Registry.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './Registry.css';

const Registry = () => {
    const { t } = useTranslation();

    // Animated SVG heart decoration with smooth transitions
    const HeartSvg = () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" className="heart-svg">
            {/* Outer Heart - Base layer */}
            <path
                className="heart-main"
                d="M150,250 C250,190 280,130 280,80 C280,40 250,10 210,10 C180,10 160,30 150,50 C140,30 120,10 90,10 C50,10 20,40 20,80 C20,130 50,190 150,250 Z"
                fill="#7095D1"
                stroke="#334EAC"
                strokeWidth="3"
            />

            {/* Middle Heart */}
            <path
                className="heart-inner"
                d="M150,230 C235,180 260,130 260,85 C260,50 235,30 205,30 C180,30 165,45 150,65 C135,45 120,30 95,30 C65,30 40,50 40,85 C40,130 65,180 150,230 Z"
                fill="#D0E3FF"
                stroke="none"
            />

            {/* Shine Heart (innermost) */}
            <path
                className="heart-shine"
                d="M80,50 Q105,20 150,65 Q195,20 220,50 Q230,60 215,80 Q190,110 150,140 Q110,110 85,80 Q70,60 80,50 Z"
                fill="#FFFFFF"
                stroke="none"
            />
        </svg>
    );

    return (
        <section className="registry-section">
            <div className="registry-container">
                <div className="registry-content">
                    <h2 className="registry-title">{t('registry.title')}</h2>

                    <div className="registry-message">
                        <p className="registry-text">{t('registry.message')}</p>
                    </div>

                    <div className="decorative-divider">
                        <span className="divider-line"></span>
                        <span className="divider-icon">♥</span>
                        <span className="divider-line"></span>
                    </div>

                    <div className="registry-thank-you">
                        <p>{t('registry.thankYou')}</p>
                        <p className="signature">Tunno & Haubuah</p>
                    </div>
                </div>

                <div className="registry-image">
                    <HeartSvg />
                </div>
            </div>
        </section>
    );
};

export default Registry;